export class MedicFavoriteExternalPrescriptionRequest {
    formattedText: string;
    favoriteMedicineName: string;
    idMedicFavoriteExternalPrescription: number;
    shareWithMedicalTeam: boolean;
}